import * as React from "react";
import type { SVGProps } from "react";
const SvgServer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6 5a1 1 0 0 0 0 2zm.01 2a1 1 0 0 0 0-2zM6 17a1 1 0 1 0 0 2zm.01 2a1 1 0 1 0 0-2zM4 3h16V1H4zm16 0a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3zm1 1v4h2V4zm0 4a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3zm-1 1H4v2h16zM4 9a1 1 0 0 1-1-1H1a3 3 0 0 0 3 3zM3 8V4H1v4zm0-4a1 1 0 0 1 1-1V1a3 3 0 0 0-3 3zm1 11h16v-2H4zm16 0a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3zm1 1v4h2v-4zm0 4a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3zm-1 1H4v2h16zM4 21a1 1 0 0 1-1-1H1a3 3 0 0 0 3 3zm-1-1v-4H1v4zm0-4a1 1 0 0 1 1-1v-2a3 3 0 0 0-3 3zm3-9h.01V5H6zm0 12h.01v-2H6z"
    />
  </svg>
);
export default SvgServer;
